import type { DemoId } from "@/demos/types";

export const ANALYTICS_EVENT_NAME = "risingpixel:analytics";

/**
 * The brief's approved minimum. Anything beyond these two is a product
 * decision, not an implementation detail.
 */
export type AnalyticsEvent =
  | { name: "experience_opened"; demoId: DemoId }
  | { name: "cta_clicked"; demoId: DemoId; ctaId: string };
